<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="6"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Activity Logs
            </h1>
          </b-col>
        </b-row>
      </b-col>

      <!-- Content Right -->
      <b-col
        class="content-header-right text-right mb-1"
        cols="6"
      >
        <div class="d-flex align-items-center justify-content-end">
          <a
            href="javascript:void(0)"
            class="nav-link nav-link-search white-bg-search"
            @click="showSearchBar = !showSearchBar"
          >
            <feather-icon
              icon="SearchIcon"
              size="21"
              class="mr-50"
            />
            <span class="align-middle">Search</span>
          </a>

          <b-input-group
            v-if="showSearchBar"
            class="input-group-merge mr-50"
          >
            <b-form-input
              v-model="searchQuery"
              placeholder="Search..."
              style="height: 40px;"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="XIcon"
                class="cursor-pointer"
                @click="searchQuery = ''; showSearchBar = !showSearchBar"
              />
            </b-input-group-append>
          </b-input-group>

          <b-dropdown
            id="dropdown-block-out-form"
            ref="filter_dropdown_user"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="dropdown-modal white-bg-dropdown"
            right
            variant="link"
          >
            <template #button-content>
              <feather-icon
                icon="FilterIcon"
                size="21"
                class="align-middle mr-50"
              />
              <span class="mr-1">Filters</span>
            </template>
            <log-filter
              :role-filter.sync="roleFilter"
              :user-filter.sync="userFilter"
              :action-filter.sync="actionFilter"
              :created-at-filter.sync="createdAtFilter"
              :role-options="roleOptions"
              :action-options="actionOptions"
              :user-options="userOptions"
              @emitHideFilter="hideFilter"
              @emitShowFilter="showFilter"
            />
          </b-dropdown>
        </div>
      </b-col>
    </b-row>

    <div v-if="createdAtFilter || roleFilter.length || userFilter.length || actionFilter.length">
      <hr class="dividerHR filter-divider">
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="12"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <ul
            class="list-inline d-inline-block mb-1"
          >
            <li
              v-for="roleVal in roleFilter"
              :key="roleVal"
              class="list-inline-item"
            >
              <b-form-tag
                class="mb-50"
                variant="danger"
                @remove="removeFromRoleFilter(roleVal)"
              >
                <span class="text-capitalize">{{ resolveRoleName(roleVal) }}</span>
              </b-form-tag>
            </li>
            <li
              v-for="userVal in userFilter"
              :key="userVal"
              class="list-inline-item"
            >
              <b-form-tag
                class="mb-50"
                variant="danger"
                @remove="removeFromUserFilter(userVal)"
              >
                <span class="text-capitalize">{{ resolveUserName(userVal) }}</span>
              </b-form-tag>
            </li>
            <li
              v-for="actionVal in actionFilter"
              :key="actionVal"
              class="list-inline-item"
            >
              <b-form-tag
                class="mb-50"
                variant="danger"
                @remove="removeFromActionFilter(actionVal)"
              >
                <span class="text-capitalize">{{ resolveActionName(actionVal) }}</span>
              </b-form-tag>
            </li>
            <li
              v-if="createdAtFilter"
              class="list-inline-item"
            >
              <b-form-tag
                class="mb-50"
                variant="danger"
                @remove="createdAtFilter = ''"
              >
                {{ createdAtFilter }}
              </b-form-tag>
            </li>
            <li
              class="list-inline-item"
            >
              <span
                class="text-danger clear-filter-text mb-50"
                @click="clearAllFilters"
              >
                Clear Filters
              </span>
            </li>
          </ul>
        </b-col>
      </b-row>
    </div>
    <!-- Table Container Card -->
    <b-card
      class="mb-3 mt-3 p-2"
    >
      <h5 class="fs-18 weight-500 text-black">
        Today
      </h5>
      <app-timeline class="ml-50 mt-2">
        <!-- FINANCIAL REPORT -->
        <app-timeline-item
          v-for="(opt, key) in todaysLogs"
          :key="key"
          class="multiple-color"
          :variant="getVariant(key)"
        >

          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
            <h6 class="weight-600">
              {{ opt.title }}
            </h6>
            <small class="text-muted">{{ dateFormatWithTime(opt.createdAt) }}</small>
          </div>
          <p
            v-if="opt.remarks"
            style="color: #333333;"
            class="mb-0"
          >
            {{ opt.remarks }}
          </p>
          <b-button
            v-if="opt.detail && opt.detail.length"
            v-b-toggle="'report-list-with-icon-' + key"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            size="sm"
            variant="outline-primary"
          >
            Details
            <feather-icon
              icon="ChevronUpIcon"
              class="ml-50 when-open"
              size="16"
            />
            <feather-icon
              icon="ChevronDownIcon"
              class="ml-50 when-closed"
              size="16"
            />
          </b-button>
          <b-collapse
            v-if="opt.detail && opt.detail.length"
            :id="'report-list-with-icon-' + key"
          >
            <b-table-simple
              borderless
              responsive
            >
              <b-tbody>
                <b-tr
                  v-for="(activityDetail, activityKey) in opt.detail"
                  :key="activityKey"
                >
                  <b-th style="width: 300px; max-width: 300px;">
                    {{ activityDetail.title }}
                  </b-th>
                  <b-td>{{ activityDetail.oldValue }}</b-td>
                  <b-td>{{ activityDetail.newValue }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-collapse>
        </app-timeline-item>
      </app-timeline>

      <h5 class="fs-18 weight-500 text-black mt-2">
        Past
      </h5>
      <app-timeline class="ml-50 mt-2">
        <!-- FINANCIAL REPORT -->
        <app-timeline-item
          v-for="(opt, key) in pastLogs"
          :key="key"
          class="multiple-color"
          :variant="getVariant(key)"
        >

          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
            <h6 class="weight-600">
              {{ opt.title }}
            </h6>
            <small class="text-muted">{{ dateFormatWithTime(opt.createdAt) }}</small>
          </div>
          <p
            v-if="opt.remarks"
            style="color: #333333;"
            class="mb-0"
          >
            {{ opt.remarks }}
          </p>
          <b-button
            v-if="opt.detail && opt.detail.length"
            v-b-toggle="'report-list-with-icon-' + key"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            size="sm"
            variant="outline-primary"
          >
            Details
            <feather-icon
              icon="ChevronUpIcon"
              class="ml-50 when-open"
              size="16"
            />
            <feather-icon
              icon="ChevronDownIcon"
              class="ml-50 when-closed"
              size="16"
            />
          </b-button>
          <b-collapse
            v-if="opt.detail && opt.detail.length"
            :id="'report-list-with-icon-' + key"
          >
            <b-table-simple
              borderless
              responsive
            >
              <b-tbody>
                <b-tr
                  v-for="(activityDetail, activityKey) in opt.detail"
                  :key="activityKey"
                >
                  <b-th style="width: 300px; max-width: 300px;">
                    {{ activityDetail.title }}
                  </b-th>
                  <b-td>{{ activityDetail.oldValue }}</b-td>
                  <b-td>{{ activityDetail.newValue }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-collapse>
        </app-timeline-item>
      </app-timeline>
    </b-card>

    <div
      v-if="totalLogs > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalLogs"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BInputGroup, BInputGroupAppend, BDropdown, BPagination, BButton,
  BTableSimple, BTbody, BTr, BTh, BTd, BCollapse, BFormTag, VBToggle,
} from 'bootstrap-vue'
import moment from 'moment'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import UserListAddNew from './UserListAddNew.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import LogFilter from './LogFilter.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BDropdown,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BCollapse,
    BFormTag,
    BButton,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,

    LogFilter,
    AppTimeline,
    AppTimelineItem,
  },
  directives: { 'b-toggle': VBToggle, Ripple },

  data() {
    return {
      showSearchBar: false,
      searchQuery: '',
      perPage: 100,
      currentPage: 1,
      totalLogs: 0,
      userFilter: [],
      roleFilter: [],
      actionFilter: [],
      createdAtFilter: '',
      todaysLogs: [],
      pastLogs: [],
      userOptions: [],
      roleOptions: [],
      actionOptions: [
        { name: 'New User Account Request', key: 'user-account-request' },
        { name: 'Send Back Account Request', key: 'user-account-send-back' },
        { name: 'Edited User', key: 'user-edit' },
        { name: 'Edited Role', key: 'role-edit' },
        { name: 'Deleted User', key: 'user-delete' },
        { name: 'Deleted Role', key: 'role-delete' },
        { name: 'Created Role', key: 'role-create' },
        { name: 'Approved', key: 'user-account-approve' },
        { name: 'Rejected', key: 'user-account-reject' },
        { name: 'Automatically disabled by System', key: 'user-account-disabled' },
      ],
    }
  },

  watch: {
    searchQuery() {
      this.getActivityLog()
    },
    userFilter() {
      this.getActivityLog()
    },
    roleFilter() {
      this.getActivityLog()
    },
    actionFilter() {
      this.getActivityLog()
    },
    createdAtFilter() {
      console.log(this.createdAtFilter)
      this.getActivityLog()
    },
  },

  beforeMount() {
    this.$http.get('directory/users/activity-log/respond-with/extra-options')
      .then(response => {
        this.roleOptions = response.data.roleOptions ?? []
        this.userOptions = response.data.userOptions ?? []
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })

    this.getActivityLog()
  },

  methods: {
    getActivityLog() {
      this.$http.get('directory/activity-logs', {
        params: {
          search: this.searchQuery,
          perPage: this.perPage,
          currentPage: this.currentPage,
          user: this.userFilter,
          role: this.roleFilter,
          action: this.actionFilter,
          createdAt: this.createdAtFilter,
        },
      })
        .then(response => {
          const logs = response.data.activityLogs || []
          this.todaysLogs = logs.filter(log => log.createdAt.includes(moment().format('YYYY-MM-DD')))
          this.pastLogs = logs.filter(log => !log.createdAt.includes(moment().format('YYYY-MM-DD')))
          this.totalLogs = response.data.total ?? 0
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    getVariant(key) {
      if (key % 4 === 0) return 'info'
      if (key % 4 === 1) return 'warning'
      if (key % 4 === 2) return 'danger'
      if (key % 4 === 3) return 'purple'
      return 'primary'
    },
    hideFilter() {
      this.$refs.filter_dropdown_user.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_user.show(true)
    },
    removeFromRoleFilter(item) {
      const index = this.roleFilter.indexOf(item)
      if (index > -1) {
        this.roleFilter.splice(index, 1)
      }
    },
    removeFromUserFilter(item) {
      const index = this.userFilter.indexOf(item)
      if (index > -1) {
        this.userFilter.splice(index, 1)
      }
    },
    removeFromActionFilter(item) {
      const index = this.actionFilter.indexOf(item)
      if (index > -1) {
        this.actionFilter.splice(index, 1)
      }
    },

    clearAllFilters() {
      this.createdAtFilter = ''
      this.roleFilter = []
      this.userFilter = []
      this.actionFilter = []
    },
    resolveUserName(id) {
      const user = this.userOptions.find(o => o._id === id)
      if (user) {
        return user.name || ''
      }
      return ''
    },
    resolveRoleName(id) {
      const role = this.roleOptions.find(o => o._id === id)
      if (role) {
        return role.role || ''
      }
      return ''
    },
    resolveActionName(id) {
      const action = this.actionOptions.find(o => o.key === id)
      if (action) {
        return action.name || ''
      }
      return ''
    },
  },
}
</script>

<style lang="scss">
  .per-page-selector {
    width: 90px;
  }
  .text-black {
    color: #000 !important;
  }
  .app-timeline .weight-600 {
    font-weight: 600 !important;
  }
  .dropdown.b-dropdown.dropdown-modal.btn-group.white-bg-dropdown button.btn.dropdown-toggle.btn-link {
    background-color: #fff !important;
    padding: 0.786rem 1.5rem  !important;
    border-radius: 5px;
    height: 38px;
  }
  .white-bg-search {
    background-color: #fff;
    border-radius: 5px;
    line-height: 28px;
    margin-right: 10px;
    white-space: nowrap;
    padding-left: 1.5rem  !important;
    padding-right: 1.5rem  !important;
  }
</style>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
